// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'reset-css'
import './assets/css/chota-grid.css'
import './assets/css/global.css'
import './assets/font-awesome/css/font-awesome.min.css'
import 'element-ui/lib/theme-chalk/index.css'
import store from './vuex/store'
import numeral from "numeral";
import {
    Pagination,
    Dialog,
    Autocomplete,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,
    Input,
    InputNumber,
    Radio,
    RadioGroup,
    RadioButton,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Switch,
    Select,
    Option,
    OptionGroup,
    Button,
    ButtonGroup,
    Table,
    TableColumn,
    DatePicker,
    TimeSelect,
    TimePicker,
    Popover,
    Tooltip,
    Breadcrumb,
    BreadcrumbItem,
    Form,
    FormItem,
    Tabs,
    TabPane,
    Tag,
    Tree,
    Alert,
    Slider,
    Icon,
    Row,
    Col,
    Upload,
    Progress,
    Spinner,
    Badge,
    Card,
    Rate,
    Steps,
    Step,
    Carousel,
    CarouselItem,
    Collapse,
    CollapseItem,
    Cascader,
    ColorPicker,
    Transfer,
    Container,
    Header,
    Aside,
    Main,
    Footer,
    Timeline,
    TimelineItem,
    Link,
    Divider,
    Image,
    Calendar,
    Backtop,
    PageHeader,
    CascaderPanel,
    Loading,
    MessageBox,
    Message,
    Notification,
    Popconfirm,
    Result,
} from 'element-ui';


import i18n from './i18n/i18n'
import VueClipboard from 'vue-clipboard2'
import axios from "axios";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Slider);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Spinner);
Vue.use(Badge);
Vue.use(Card);
Vue.use(Rate);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Cascader);
Vue.use(ColorPicker);
Vue.use(Transfer);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Link);
Vue.use(Divider);
Vue.use(Image);
Vue.use(Calendar);
Vue.use(Backtop);
Vue.use(PageHeader);
Vue.use(CascaderPanel);
Vue.use(Popconfirm);
Vue.use(Result);

Vue.use(Loading.directive);

Vue.use(VueClipboard)

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

Vue.prototype.toHHMMSS = function (sec_num) {
    sec_num = Math.round(sec_num);
    var hours   = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours   < 10) {hours   = "0"+hours;}
    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}
    return hours+':'+minutes+':'+seconds;
}

Vue.filter("formatNumber", function (value) {
  return numeral(value).format("0,0"); // displaying other groupings/separators is possible, look at the docs
});

router.onError(error => {
  if ((/Loading chunk \d* failed./i.test(error.message) || /Loading CSS chunk \d* failed./i.test(error.message)) && navigator.onLine) {
    window.location.reload()
  }
});

window.onerror = function(mMsg, mSource, mLineNo, mColNo, error){
  if (mMsg.toLowerCase().indexOf("unexpected token '<'") > -1 && navigator.onLine){
    window.location.reload();
  }
};

// Axios config
axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.timeout = 600000
axios.defaults.headers['Content-Type'] = 'application/json'
axios.defaults.responseType = 'json'
axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = token ? `Bearer ${token}` : '';
  }
  return config;
});
axios.interceptors.response.use(
response => response,
error => {
  if (error.response && error.response.status === 403 && error.response.config.url !== 'auth/login') {
    alert('Session timeout. Please login again.');

    localStorage.clear()
    sessionStorage.clear()
    document.location.href = '/';
  }

  // Retry transient connection failures (e.g. "Request aborted", network errors)
  // on idempotent GET requests only, so a dropped connection doesn't surface as
  // an error toast / empty panel to the user.
  const config = error.config;
  const isTransient = !error.response && (error.code === 'ECONNABORTED' || error.message === 'Network Error');
  const isIdempotent = config && (config.method || 'get').toLowerCase() === 'get';
  const MAX_RETRIES = 3;
  if (isTransient && isIdempotent) {
    config.__retryCount = config.__retryCount || 0;
    if (config.__retryCount < MAX_RETRIES) {
      config.__retryCount += 1;
      const delay = 500 * config.__retryCount; // simple linear backoff
      return new Promise(resolve => setTimeout(resolve, delay)).then(() => axios(config));
    }
  }

  return Promise.reject(error);
});

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: 'https://cea416506acf424a92f57351df903af5@o4504294377390080.ingest.sentry.io/4504294378635264',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: ["amz-api-eu.kec-app.com"],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.01,

    ignoreErrors: [
      /ChunkLoadError$/,
      /Loading chunk \d* failed./i,
      /Loading CSS chunk \d* failed./,
      /Network Error/,
      /Request aborted/,
    ]
  });
}

Vue.prototype.application_version = require('../package.json').version;

new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>'
})
